import {createAction} from 'redux-actions'
import {urlListaProductosMenu, urlServicios} from "../../constants/urls";

// actions para productos
export const hasError = createAction('PRODUCTOS_MENU_HAS_ERROR');
export const isLoading = createAction('PRODUCTOS_MENU_IS_LOADING');
export const data = createAction('SET_DATA_PRODUCTOS_MENU');
export const setDataUrlRenovaciones = createAction('SET_DATA_URL_RENOVACIONES');

// actions para servicios
export const setDataServicios = createAction('SET_DATA_SERVICIOS');
export const setServiciosIsLoading = createAction('SET_SERVICIOS_IS_LOADING');
export const setServiciosHasError = createAction('SET_SERVICIOS_HAS_ERROR');

// fetch del menu de Servicios y manejo de redux
export const ServiciosMenuFetch = (dataBody = {}) => async (dispatch, getState) => {
  const state = getState();
  const dataUsuario = state && state.datosUsuarios && state.datosUsuarios.dataUsuario;
  const idUsuario = (dataUsuario && (dataUsuario.cliCodigoCore || dataUsuario.cedula || dataUsuario.correo)) || '';

  const date = state.rServicios && state.rServicios.date;
  const cachedUserId = state.rServicios && state.rServicios.userId;
  const now = new Date();

  // Si la caché pertenece al MISMO usuario y han pasado menos de 2 minutos, usamos la caché
  if (idUsuario && cachedUserId && cachedUserId === idUsuario && date && date !== '' && (now - date < 2 * 60 * 1000)) {
    return;
  }

  // Si cambió el usuario (o no coincide la caché), limpiamos la caché del usuario anterior antes de consultar
  if (cachedUserId && cachedUserId !== idUsuario) {
    dispatch(setDataServicios({ enlaces: [], userId: idUsuario }));
  }

  const payload = {
    idUsuario,
    ...dataBody,
  };

  dispatch(setServiciosIsLoading());
  await fetch(urlServicios, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  })
    .then(response => response.json())
    .then(data => {
      console.log('data es lo siguiente ', data);
      if (data.transaccion) {
        const enlaces = (data.enlaces || []).sort((enlaceA, enlaceB) => (enlaceA.parNombre > enlaceB.parNombre) ? 1 : -1);
        dispatch(setDataServicios({ enlaces, userId: idUsuario }));
      } else {
        dispatch(setDataServicios({ enlaces: [], userId: idUsuario }));
      }
    })
    .catch((e) => {
      dispatch(setServiciosHasError(`Error al consultar el menu de servicios: ${e}`));
    });
};

// fetch del menu de Productos y manejo de redux
export const ProductosMenuFetch = () => async (dispatch, getState) => {
  const state = getState();
  const date = state.datosProductosMenu.date;
  const now = new Date();
  if (date && date !== '' && now - date < 2 * 60 * 1000) {
    return;
  }
  dispatch(isLoading());
  //console.log('urlListaProductosMenu', urlListaProductosMenu)
  await fetch(urlListaProductosMenu)
    .then(response => response.json())
    .then(dato => {
      console.log(dato)

      const {transaccion, ramos, urlRenovaciones} = dato;
      if (transaccion) {
        dispatch(data(ramos));
        if (urlRenovaciones) {
          dispatch(setDataUrlRenovaciones(urlRenovaciones));
        }
      }
    })
    .catch((e) => {
      //console.log(e)
      dispatch(hasError('Error al consultar menus'));
    });
};
